export const MAX_STAR_TITLE = 5;
export const PARAM_SORT = 'sort';
export const PARAM_PER_PAGE = 'per_page';
export const PARAM_PAGE = 'page';
export const PARAM_LANGUAGE = 'languages';
export const DEFAULT_PARAM_LANGUAGE = 'all';
export const PARAM_RATING = 'rating';
export const PRODUCT_REVIEW_LIST_API_URL = '/api/product-review';
export const LIST_LOAD_DEBOUNCE_TIME = 800;
export const TRANSLATE_FAILED_ERROR_TIME = 4000;
export const DIALOG_OFFSET: number = 120;
